import React from 'react';
import './Footer.css';
import hostnine from '../images/hostnine.png';
import { Link, NavLink } from 'react-router-dom';
import {  Nav } from 'react-bootstrap';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer class="main-footer">
        <div class="container">
            <div class="row pb-5">
                <div class="col-md-3">
                    <h6>Menu</h6>
                    <ul class="footer-nav">
                <li><Nav.Link as={NavLink} to="/">Home</Nav.Link></li>
            <li><Nav.Link as={NavLink} to="/about">About us</Nav.Link></li>
            <li><Nav.Link as={NavLink} to="/timetables">Time Tables</Nav.Link></li>
            <li><Nav.Link as={NavLink} to="/results">Results</Nav.Link></li>
            <li><Nav.Link as={NavLink} to="/circulars">Circulars</Nav.Link></li>
            <li><Nav.Link as={NavLink} to="/grievanances">Grievances Redressal</Nav.Link></li>
            <li><Nav.Link as={NavLink} to="/contact">Contact</Nav.Link></li>
            <li><Nav.Link as={NavLink} to="/ourstaff">Our Staff</Nav.Link></li> 
            </ul>
                </div>
                
                <div class="col-md-4">
                    <h6>Get in Touch</h6>
                    <p class="font-14"><b>Andhra Loyola College is affiliated with Krishna University (KrU) , Machilipatnam</b></p>
                    <ul class="plain-list footer-address">
                        <li class="para-agileits-w3layouts text-white">
						<i class="fas fa-map-marker pr-3"></i>Vijayawada,Andhra Pradesh,India,Pin- 520008.</li>
                        <li class="para-agileits-w3layouts text-white">
						<i class="fas fa-phone"></i>91-866 2473251,2476082</li>
                        <li class="para-agileits-w3layouts">
						<i class="far fa-envelope-open pr-2"></i>
						<a href="mailto:mail@example.com" class=" text-white">alccoe@gmail.com</a></li>
                    </ul>
                </div>
                <div class="col-md-5">
                    <h6>Our Directions</h6>
                    <iframe width="100%" height="200" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3825.299734240971!2d80.65939421486434!3d16.510958888609295!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35facb8c3c56f1%3A0x3b1255c6bd993f4c!2sAndhra+Loyola+College!5e0!3m2!1sen!2sin!4v1539152538258"></iframe>
                </div>
            </div>
           
        </div>
       <div class="bottom-footer">
        <div class="container">
         
                <div class="row">
                    <div class="col-md-6 copywrite">
                    &copy; 2025 ALC. All Rights Reserved. Vijayawada, Andhra Pradesh, India
                </div>
                  <div class="col-md-6">
                    <div class="text-end hostnine"><a href="https://hostnineindia.com/project-grid.html" target="_blank">Hosting and Maintained by:<img src={hostnine} alt="HostNine India Logo"/></a>
					</div>
                </div>
                </div>
            </div>
			</div>
           
       
    </footer>
  );
};

export default Footer;
